import round from "../../../utils/round";

/**
 *
 * @param {TriggerProps} trigger
 * @param {TimelineMapProps} timeline
 */
const checkSkipStep = (trigger, timeline) => {
  const skip = timeline.get("o_skip-first");

  if (skip) {
    /** Max offset values */
    const max = [0];

    /** Timeline steps */
    const steps = /** @type {Map<Number, StepProps>} */ (timeline.get("steps"));

    /** Timeline offsets duration */
    const OFFSETS = /** @type {Number} */ (timeline.get("offsets-duration"));

    /** Timeline global duration */
    const DURATION = /** @type {Number} */ (timeline.get("o_duration"));

    /** If "0" (first) step is deleted, the timeline is processed */
    if (!steps.has(0)) {
      return;
    }

    /** Delete the first step that should be skipped */
    steps.delete(0);

    /** Get the offsets of the next available step */
    const next = /** @type {Array<Number>} */ (steps.get(1)?.get("offsets"));

    /** Time difference */
    const difference = next[0] - 0;

    for (const step of steps.values()) {
      const offsets = /** @type {Array<Number>} */ (step.get("offsets"));

      offsets[0] = offsets[0] - difference;
      offsets[1] = offsets[1] - difference;

      max.push(offsets[1]);
    }

    /** Get the max offset to set a new duration */
    const newDuration = Math.max(...max);

    timeline.set("o_duration", round((newDuration / OFFSETS) * DURATION));
    timeline.set("offsets-duration", newDuration);
  }
};

export default checkSkipStep;
